import 'react';
import 'prop-types';
import '../types/props.js';
import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import Heading from '../Heading/index.js';

var AlertTitle = styled(Heading).withConfig({
  displayName: "styled__AlertTitle",
  componentId: "sc-14yopcx-0"
})(["font-weight:", ";&&:not(:last-child){margin-bottom:", "em;}&{", ";}"], theme('fannypack.fontWeights.semibold'), space(2), theme('fannypack.Alert.Title.base'));
var AlertClose = styled(Button).withConfig({
  displayName: "styled__AlertClose",
  componentId: "sc-14yopcx-1"
})(["width:24px;min-height:24px;padding:0;text-align:right;", ";&:hover{background-color:", ";&{", ";}}", ";"], function (props) {
  return props.isAbsolute ? css(["position:absolute;right:", "rem;top:", "rem;"], space(2), space(2)) : css(["margin:0 ", "rem;"], space(2));
}, palette('white700'), theme('fannypack.Alert.Close.hover'), theme('fannypack.Alert.Close.base'));
var tintAttributes = css(["background-color:", ";border-top-width:0;border-right-width:0;border-bottom-width:0;color:", ";fill:", ";", ";"], function (props) {
  return props.type && palette(props.type + "Tint")(props);
}, function (props) {
  return props.type && palette(props.type + "TintInverted")(props);
}, function (props) {
  return props.type && palette(props.type + "TintInverted")(props);
}, theme('fannypack.Alert.tint'));
var Alert = styled(Box).withConfig({
  displayName: "styled__Alert",
  componentId: "sc-14yopcx-2"
})(["background-color:white;border:1px solid ", ";border-left:4px solid ", ";border-radius:4px;position:relative;&{", ";}&{", ";}"], palette('white800'), function (props) {
  return props.type && palette(props.type)(props);
}, function (props) {
  return props.hasTint && tintAttributes;
}, theme('fannypack.Alert.base'));

export default Alert;
export { Alert, AlertClose, AlertTitle };
